import { TranslationKeys } from '~frontend-common/i18n/english/validation.i18n';

const keys: TranslationKeys = {
  validation: {
    error: {
      accountLength: 'Le numéro de compte doit comporter entre 7 et 12 chiffres.',
      alternaBankTransit: 'Le numéro de transit de Banque Alterna doit être 00016',
      alternaSavingsTransit: 'Le numéro de transit de Caisse Alterna doit être 00646',
      between5And12DigitsAccount: 'Le numéro de compte doit comporter entre 5 et 12 chiffres',
      between6And9DigitsAccount: 'Le numéro de compte doit comporter entre 6 et 9 chiffres',
      between7And10DigitsAccount: 'Le numéro de compte doit comporter entre 7 et 10 chiffres',
      between7And12DigitsAccount: 'Le numéro de compte doit comporter entre 7 et 12 chiffres',
      booleanRequired: 'Devrait être un booléen',
      choiceNotIncluded: "Le choix n'est pas inclus dans la liste",
      cityRequired: 'Ville est requise',
      countryInvalid: 'Le pays doit être Canada',
      countryRequired: 'Le pays est requis',
      creditorsExceedLength: 'Le nombre de créditeurs excède le nombre de voitures louées',
      mortgageLendersExceedLength: "Le nombre de créditeurs excède le nombre d'hypothèques",
      dateGreaterThanToday: "Ne doit pas être plus grand qu'aujourd'hui",
      dateInferiorThanToday: "Doit être plus grand qu'aujourd'hui",
      dateInvalid: 'Doit être une date valide',
      driverLicenceG2BeforeG1_self: 'Votre âge d’obtention du permis G2 doit être au moins égal à celui du G1',
      driverLicenceG2BeforeG1_other:
        'L’âge au moment de l’obtention du permis G2 doit être au moins égal à celui du G1',
      driverLicenceGSameOrBeforeG2_self: 'Votre âge d’obtention du permis G doit être d’au moins un an après le G2',
      driverLicenceGSameOrBeforeG2_other:
        'L’âge de ce conducteur au moment de l’obtention du permis G d’au moins un an après le G2',
      driverLicenceMaxGapBeforeG: "L'obtention du permis G doit être dans un délai de 5 ans",
      eightDigitsAccount: 'Le numéro de compte doit comporter 8 chiffres',
      endDateInvalid: 'Doit être une date valide',
      fiveDigitsTransit: 'Le numéro de transit doit comporter 5 chiffres',
      invalidAddress: "L'adresse est requise",
      invalidAlphanumeric: 'Doit contenir des chiffres ou des lettres uniquement',
      invalidStringLength: 'Doit être au moins 2 caractères',
      invalidArraySize: "Nombre d'items est incorrect",
      invalidCarDateOfClaim: 'Date de réclamation ne doit pas avoir plus de 6 ans',
      invalidCarPossessionDate: "L'année de possession doit concorder avec l'année de votre voiture",
      invalidCharacters: 'Contient des caractères invalides',
      invalidConstructionYear: 'Doit être une année valide',
      invalidConvictionYear: 'Conviction ne doit pas avoir plus de 5 ans',
      invalidCurrency: 'Doit être une valeur valide',
      invalidEffectiveDates: 'Doit inclure une date pour chaque type de produit',
      invalidFiledClaims: 'Doit être entre 0 et 2.',
      invalidFireHydrantDistance: 'Sélectionnez une distance valide',
      invalidFireStationDistance: 'Sélectionnez une distance valide',
      invalidDriverLicenceClass: 'Dois avoir une classe de permis de conduire valide',
      invalidDriverLicenceObtainedAtAge: 'Doit être âgé entre 16 ans et l’âge actuel du conducteur',
      invalidFirstDriverLicenceAge: 'Doit être âgé de 16 ans ou plus',
      invalidFloorNumber: "L'étage de la propriété est invalide",
      invalidHomeDimension: 'La taille de la propriété est requise',
      invalidHomeReconstructionCost: 'Le montant doit être entre 80 000 et 2M',
      invalidHomeDateOfClaim: 'Date de réclamation ne doit pas avoir plus de 8 ans',
      invalidFinancialInstitutionNumber: "Le numéro d'institution doit comporter 3 chiffres",
      invalidLicenseAgeToBirthday: 'Doit être inférieur à votre âge',
      invalidLicenceNumber: 'Numéro de permis de conduire invalide',
      invalidMonth: 'Le mois doit être valide',
      invalidMoveInDate: 'Le déménagement doit être après la date de construction',
      mustBeAfterConstructionYear: 'Doit être après la date de construction',
      invalidName: 'Doit être au moins 2 lettres',
      invalidNumberOfBathrooms: 'Le nombre de salles de bain doit être entre 1 et 9.',
      invalidNumberOfStoreys: "Le nombre d'étages doit être entre 1 et 9.",
      invalidNumberOfUnits: "Doit être un nombre valide d'unités",
      invalidNumberOfYearsInsured: "Doit être un nombre d'années valide",
      invalidNumberYearsContinuouslyInsured: "Le nombre d'années doit être entre 0 et 5",
      invalidNumberYearsWithCurrentInsurer: "Le nombre d'années doit être entre 0 et 4",
      invalidPhoneNumber: 'Doit être un numéro de téléphone valide',
      invalidPhoneNumberCountry: 'Doit être un numéro de téléphone valide au Canada ou aux États-Unis',
      policyNumbersShouldBeDifferent:
        'Ce numéro de police est déjà utilisé pour un autre produit au sein de cette application.',
      invalidPolicyNumber: {
        economical: 'Le format du numéro de police de Economical doit être 123456789',
        intact:
          "Le format du numéro de police de Intact doit être xxx-xxxx pour le Québec et xxxxxxxxx pour l'Ontario.",
        unique: 'Le format du numéro de police de Unique doit être 12345678',
        promutuel: 'Le format du numéro de police de Promutuel doit être x0123456789-01',
        travelers: 'Le format du numéro de police de Travelers doit être 0123456789 ou APP0123456',
        wawanesa: 'Le format du numéro de police de Wawanesa doit être 12345678',
      },
      invalidPropertySize: 'La taille de la propriété est invalide',
      invalidProvince: 'Province invalide',
      invalidPurchaseKmOnOdometer: 'Doit être entre 0 et 9999 km',
      invalidInstallationYear: "Doit être entre l'année de construction du bâtiment et l'année courante",
      invalidSize: 'Doit être une taille valide',
      invalidString: 'Valeur invalide',
      invalidUnit: "Numéro d'unité ou adresse de case postale invalide",
      invalidVin: 'NIV invalide',
      invalidWaterTankYear: "Doit être entre 1900 et aujourd'hui",
      invalidYearlyDaysOutsideOfProvince: 'Valeur invalide',
      invalidYearlyKilometers: 'Doit être entre 1 000 et 999 000.',
      invalidDailyKilometers: 'Doit être entre 1 et 999.',
      invalideAge: 'Âge invalide',
      invalidValue: 'Valeur invalide',
      latitude: 'La latitude doit être entre -90 et 90',
      longitude: 'La longitude doit être entre -180 et 180',
      mainDriverIsRequired: 'Un conducteur principal est requis',
      nineDigitsAccount: 'Le numéro de compte doit comporter 9 chiffres',
      policyLength: 'Le numéro de police doit contenir au moins 4 caractères',
      possessionDateAfter: "La date d'acquisition doit être la même année ou après l'année du modèle de la voiture.",
      presidentChoiceTransit: 'Le numéro de transit de la banque Choix du Président doit être 02002',
      provinceRequired: 'Choisissez votre province',
      required: 'Ce champ est requis',
      selectOption: 'Sélectionnez une option de la liste',
      sevenDigitsAccount: 'Le numéro de compte doit comporter 7 chiffres',
      sevenOrTwelveAccount: 'Le numéro de compte doit comporter 7 ou 12 chiffres',
      sixDigitsAccount: 'Le numéro de compte doit comporter 6 chiffres',
      startWith00Transit: 'Le numéro de transit doit commencer par 00XXX et comporter 5 chiffres',
      startWith10Transit: 'Le numéro de transit doit commencer par 10XXX et comporter 5 chiffres',
      startWith80Transit: 'Le numéro de transit doit commencer par 80XXX et comporter 5 chiffres',
      streetNameRequired: 'Nom de la rue est requis',
      streetNumberRequired: 'Numéro de rue est requis',
      tangerineTransit: 'Le numéro de transit de Tangerine doit être 00152',
      tenDigitsAccount: 'Le numéro de compte doit comporter 10 chiffres',
      transitLength: 'Le numéro de transit doit comporter 5 chiffres',
      twelveDigitsAccount: 'Le numéro de compte doit comporter 12 chiffres',
      unknownProduct: 'Ce produit est inconnu.',
      undefinedRequired: 'Ne doit pas être défini',
      validEmail: 'Entrez un courriel valide',
      validPassword: 'Doit être un mot de passe valide',
      validPostalCode: 'Le format valide est H3B 2Y4',
      wealthsimpleTransit: 'Le numéro de transit de Wealthsimple doit être 00001',
    },
  },
};

export default keys;
